import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialLoadingCircle1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.145 14.47v4.58h4.57v-4.58Zm3.05 3.05h-1.53V16H28.2Zm-1.53 6.1H22.1v4.57h4.57Zm-1.52 3.04h-1.52v-1.52h1.52ZM28.2 11.43V3.81h-7.62v7.62Zm-6.1-6.1h4.57V9.9H22.1ZM19.045.76h-7.61v7.62h7.61Zm-1.52 6.09h-4.57V2.28h4.57Zm-4.57 19.81h4.57v4.58h-4.57Zm-9.14-3.04h4.57v4.57h-4.57Zm1.52-16.77h1.52v1.53h-1.52ZM2.285 16h1.53v1.52h-1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialLoadingCircle1
